module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens33-87cd64da22a0c9a6184d1f51a9416886.jpg";